<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('tournaments')"
      :columns="columns"
      :column_search="true"
      resource_url="/tournament/pool/datatables"
      mode="grid"
      grid_class="is-col-min-12"
      :page_length="25"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <figure class="image is-64x64 m-auto" @click="view(item)">
              <v-lazy-image
                src="https://cdn-icons-png.freepik.com/512/8835/8835736.png"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="view(item)">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ format_date(item.date) }} - {{ item.place }}
                </p>
                <div class="tags" v-if="item.settings && item.settings.players">
                  <div
                    class="tag"
                    v-bind:class="{
                      'is-primary': player != item.champion,
                      'is-warning': player == item.champion,
                    }"
                    v-for="(player, pidx) in item.settings.players"
                  >
                    <span v-if="player != item.champion">{{ player }}</span>
                    <div v-else>
                      <span class="icon">
                        <i class="fa fa-trophy"></i>
                      </span>
                      <span>{{ player }}</span>
                    </div>
                  </div>
                </div>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <tournament-modal ref="tournament_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import TournamentModal from "./tournament_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "TournamentsDatatable",
  components: { GenericTable, TournamentModal, VLazyImage },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          searchable: false,
          width: "15%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return v.format_date(row.date) || "";
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.tournament_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete tournament?"),
        v,
        () => {
          del("/tournament/pool", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    view(item) {
      let v = this;
      v.$refs.tournament_modal.view_modal(item.uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
